import { Component } from '@angular/core';
import { UserChangePasswordFormComponent, CardComponent } from '@spartacus/organization/administration/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FocusDirective, FormErrorsComponent } from '@spartacus/storefront';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-user-change-password-form',
    templateUrl: './efa-user-change-password-form.component.html',
    imports: [FormsModule, ReactiveFormsModule, CardComponent, FocusDirective, RouterLink, FormErrorsComponent, AsyncPipe, TranslatePipe]
})
export class EfaUserChangePasswordFormComponent extends UserChangePasswordFormComponent { }
